// General Settings Actions

import {
  GET_VAT_PERIOD_LIST,
  GET_VAT_PERIOD_LIST_SUCCESS,
  GET_VAT_PERIOD_LIST_FAILURE,
  GET_VAT_PERIOD_DETAILS,
  GET_VAT_PERIOD_DETAILS_SUCCESS,
  GET_VAT_PERIOD_DETAILS_FAILURE,
  ADD_VAT_PERIOD,
  ADD_VAT_PERIOD_SUCCESS,
  ADD_VAT_PERIOD_FAILURE,
  UPDATE_VAT_PERIOD,
  UPDATE_VAT_PERIOD_SUCCESS,
  UPDATE_VAT_PERIOD_FAILURE,
  DELETE_VAT_PERIOD,
  DELETE_VAT_PERIOD_SUCCESS,
  DELETE_VAT_PERIOD_FAILURE,
  GET_RENEWAL_FREQUENCIES_LIST,
  GET_RENEWAL_FREQUENCIES_LIST_SUCCESS,
  GET_RENEWAL_FREQUENCIES_LIST_FAILURE,
  GET_RENEWAL_FREQUENCIES_DETAILS,
  GET_RENEWAL_FREQUENCIES_DETAILS_SUCCESS,
  GET_RENEWAL_FREQUENCIES_DETAILS_FAILURE,
  ADD_RENEWAL_FREQUENCIES,
  ADD_RENEWAL_FREQUENCIES_SUCCESS,
  ADD_RENEWAL_FREQUENCIES_FAILURE,
  UPDATE_RENEWAL_FREQUENCIES,
  UPDATE_RENEWAL_FREQUENCIES_SUCCESS,
  UPDATE_RENEWAL_FREQUENCIES_FAILURE,
  DELETE_RENEWAL_FREQUENCIES,
  DELETE_RENEWAL_FREQUENCIES_SUCCESS,
  DELETE_RENEWAL_FREQUENCIES_FAILURE,
  GET_UNIT_FREQUENCIES_LIST,
  GET_UNIT_FREQUENCIES_LIST_SUCCESS,
  GET_UNIT_FREQUENCIES_LIST_FAILURE,
  GET_UNIT_FREQUENCIES_DETAILS,
  GET_UNIT_FREQUENCIES_DETAILS_SUCCESS,
  GET_UNIT_FREQUENCIES_DETAILS_FAILURE,
  ADD_UNIT_FREQUENCIES,
  ADD_UNIT_FREQUENCIES_SUCCESS,
  ADD_UNIT_FREQUENCIES_FAILURE,
  UPDATE_UNIT_FREQUENCIES,
  UPDATE_UNIT_FREQUENCIES_SUCCESS,
  UPDATE_UNIT_FREQUENCIES_FAILURE,
  DELETE_UNIT_FREQUENCIES,
  DELETE_UNIT_FREQUENCIES_SUCCESS,
  DELETE_UNIT_FREQUENCIES_FAILURE,
  GET_MASTER_TIME_FRAME_LIST,
  GET_MASTER_TIME_FRAME_LIST_SUCCESS,
  GET_MASTER_TIME_FRAME_LIST_FAILURE,
  GET_MASTER_TIME_FRAME_DETAILS,
  GET_MASTER_TIME_FRAME_DETAILS_SUCCESS,
  GET_MASTER_TIME_FRAME_DETAILS_FAILURE,
  ADD_MASTER_TIME_FRAME,
  ADD_MASTER_TIME_FRAME_SUCCESS,
  ADD_MASTER_TIME_FRAME_FAILURE,
  UPDATE_MASTER_TIME_FRAME,
  UPDATE_MASTER_TIME_FRAME_SUCCESS,
  UPDATE_MASTER_TIME_FRAME_FAILURE,
  DELETE_MASTER_TIME_FRAME,
  DELETE_MASTER_TIME_FRAME_SUCCESS,
  DELETE_MASTER_TIME_FRAME_FAILURE,
  GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST,
  GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_SUCCESS,
  GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_FAILURE,
  GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST,
  GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST_SUCCESS,
  GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST_FAILURE,
  UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE,
  UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_SUCCESS,
  UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_FAILURE,
  GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST,
  GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_SUCCESS,
  GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_FAILURE,
  UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER,
  UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_SUCCESS,
  UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_FAILURE,
} from "./actionType";

// Get Vat Period List
export const getVatPeriodList = () => ({
  type: GET_VAT_PERIOD_LIST,
});

export const getVatPeriodListSuccess = (data) => ({
  type: GET_VAT_PERIOD_LIST_SUCCESS,
  payload: data,
});

export const getVatPeriodListFailure = (data) => ({
  type: GET_VAT_PERIOD_LIST_FAILURE,
  payload: data,
});

// Get Vat Period Details
export const getVatPeriodDetails = (data) => ({
  type: GET_VAT_PERIOD_DETAILS,
  payload: data,
});

export const getVatPeriodDetailsSuccess = (data) => ({
  type: GET_VAT_PERIOD_DETAILS_SUCCESS,
  payload: data,
});

export const getVatPeriodDetailsFailure = (data) => ({
  type: GET_VAT_PERIOD_DETAILS_FAILURE,
  payload: data,
});

// Add Vat Period
export const addVatPeriod = (data) => ({
  type: ADD_VAT_PERIOD,
  payload: data,
});

export const addVatPeriodSuccess = (data) => ({
  type: ADD_VAT_PERIOD_SUCCESS,
  payload: data,
});

export const addVatPeriodFailure = (data) => ({
  type: ADD_VAT_PERIOD_FAILURE,
  payload: data,
});

// Update Vat Period
export const updateVatPeriod = (data) => ({
  type: UPDATE_VAT_PERIOD,
  payload: data,
});

export const updateVatPeriodSuccess = (data) => ({
  type: UPDATE_VAT_PERIOD_SUCCESS,
  payload: data,
});

export const updateVatPeriodFailure = (data) => ({
  type: UPDATE_VAT_PERIOD_FAILURE,
  payload: data,
});

// Delete Vat Period
export const deleteVatPeriod = (data) => ({
  type: DELETE_VAT_PERIOD,
  payload: data,
});

export const deleteVatPeriodSuccess = (data) => ({
  type: DELETE_VAT_PERIOD_SUCCESS,
  payload: data,
});

export const deleteVatPeriodFailure = (data) => ({
  type: DELETE_VAT_PERIOD_FAILURE,
  payload: data,
});

// Get Renewal Frequencies List
export const getRenewalFrequenciesList = () => ({
  type: GET_RENEWAL_FREQUENCIES_LIST,
});

export const getRenewalFrequenciesListSuccess = (data) => ({
  type: GET_RENEWAL_FREQUENCIES_LIST_SUCCESS,
  payload: data,
});

export const getRenewalFrequenciesListFailure = (data) => ({
  type: GET_RENEWAL_FREQUENCIES_LIST_FAILURE,
  payload: data,
});

// Get Renewal Frequencies Details
export const getRenewalFrequenciesDetails = (data) => ({
  type: GET_RENEWAL_FREQUENCIES_DETAILS,
  payload: data,
});

export const getRenewalFrequenciesDetailsSuccess = (data) => ({
  type: GET_RENEWAL_FREQUENCIES_DETAILS_SUCCESS,
  payload: data,
});

export const getRenewalFrequenciesDetailsFailure = (data) => ({
  type: GET_RENEWAL_FREQUENCIES_DETAILS_FAILURE,
  payload: data,
});

// Add Renewal Frequencies
export const addRenewalFrequencies = (data) => ({
  type: ADD_RENEWAL_FREQUENCIES,
  payload: data,
});

export const addRenewalFrequenciesSuccess = (data) => ({
  type: ADD_RENEWAL_FREQUENCIES_SUCCESS,
  payload: data,
});

export const addRenewalFrequenciesFailure = (data) => ({
  type: ADD_RENEWAL_FREQUENCIES_FAILURE,
  payload: data,
});

// Update Renewal Frequencies
export const updateRenewalFrequencies = (data) => ({
  type: UPDATE_RENEWAL_FREQUENCIES,
  payload: data,
});

export const updateRenewalFrequenciesSuccess = (data) => ({
  type: UPDATE_RENEWAL_FREQUENCIES_SUCCESS,
  payload: data,
});

export const updateRenewalFrequenciesFailure = (data) => ({
  type: UPDATE_RENEWAL_FREQUENCIES_FAILURE,
  payload: data,
});

// Delete Renewal Frequencies
export const deleteRenewalFrequencies = (data) => ({
  type: DELETE_RENEWAL_FREQUENCIES,
  payload: data,
});

export const deleteRenewalFrequenciesSuccess = (data) => ({
  type: DELETE_RENEWAL_FREQUENCIES_SUCCESS,
  payload: data,
});

export const deleteRenewalFrequenciesFailure = (data) => ({
  type: DELETE_RENEWAL_FREQUENCIES_FAILURE,
  payload: data,
});

// Get Unit Frequencies List
export const getUnitFrequenciesList = () => ({
  type: GET_UNIT_FREQUENCIES_LIST,
});

export const getUnitFrequenciesListSuccess = (data) => ({
  type: GET_UNIT_FREQUENCIES_LIST_SUCCESS,
  payload: data,
});

export const getUnitFrequenciesListFailure = (data) => ({
  type: GET_UNIT_FREQUENCIES_LIST_FAILURE,
  payload: data,
});

// Get Unit Frequencies Details
export const getUnitFrequenciesDetails = (data) => ({
  type: GET_UNIT_FREQUENCIES_DETAILS,
  payload: data,
});

export const getUnitFrequenciesDetailsSuccess = (data) => ({
  type: GET_UNIT_FREQUENCIES_DETAILS_SUCCESS,
  payload: data,
});

export const getUnitFrequenciesDetailsFailure = (data) => ({
  type: GET_UNIT_FREQUENCIES_DETAILS_FAILURE,
  payload: data,
});

// Add Unit Frequencies
export const addUnitFrequencies = (data) => ({
  type: ADD_UNIT_FREQUENCIES,
  payload: data,
});

export const addUnitFrequenciesSuccess = (data) => ({
  type: ADD_UNIT_FREQUENCIES_SUCCESS,
  payload: data,
});

export const addUnitFrequenciesFailure = (data) => ({
  type: ADD_UNIT_FREQUENCIES_FAILURE,
  payload: data,
});

// Update Unit Frequencies
export const updateUnitFrequencies = (data) => ({
  type: UPDATE_UNIT_FREQUENCIES,
  payload: data,
});

export const updateUnitFrequenciesSuccess = (data) => ({
  type: UPDATE_UNIT_FREQUENCIES_SUCCESS,
  payload: data,
});

export const updateUnitFrequenciesFailure = (data) => ({
  type: UPDATE_UNIT_FREQUENCIES_FAILURE,
  payload: data,
});

// Delete Unit Frequencies
export const deleteUnitFrequencies = (data) => ({
  type: DELETE_UNIT_FREQUENCIES,
  payload: data,
});

export const deleteUnitFrequenciesSuccess = (data) => ({
  type: DELETE_UNIT_FREQUENCIES_SUCCESS,
  payload: data,
});

export const deleteUnitFrequenciesFailure = (data) => ({
  type: DELETE_UNIT_FREQUENCIES_FAILURE,
  payload: data,
});

// Get Master Time Frame List
export const getMasterTimeFrameList = () => ({
  type: GET_MASTER_TIME_FRAME_LIST,
});

export const getMasterTimeFrameListSuccess = (data) => ({
  type: GET_MASTER_TIME_FRAME_LIST_SUCCESS,
  payload: data,
});

export const getMasterTimeFrameListFailure = (data) => ({
  type: GET_MASTER_TIME_FRAME_LIST_FAILURE,
  payload: data,
});

// Get Master Time Frame Details
export const getMasterTimeFrameDetails = (data) => ({
  type: GET_MASTER_TIME_FRAME_DETAILS,
  payload: data,
});

export const getMasterTimeFrameDetailsSuccess = (data) => ({
  type: GET_MASTER_TIME_FRAME_DETAILS_SUCCESS,
  payload: data,
});

export const getMasterTimeFrameDetailsFailure = (data) => ({
  type: GET_MASTER_TIME_FRAME_DETAILS_FAILURE,
  payload: data,
});

// Add Master Time Frame
export const addMasterTimeFrame = (data) => ({
  type: ADD_MASTER_TIME_FRAME,
  payload: data,
});

export const addMasterTimeFrameSuccess = (data) => ({
  type: ADD_MASTER_TIME_FRAME_SUCCESS,
  payload: data,
});

export const addMasterTimeFrameFailure = (data) => ({
  type: ADD_MASTER_TIME_FRAME_FAILURE,
  payload: data,
});

// Update Master Time Frame
export const updateMasterTimeFrame = (data) => ({
  type: UPDATE_MASTER_TIME_FRAME,
  payload: data,
});

export const updateMasterTimeFrameSuccess = (data) => ({
  type: UPDATE_MASTER_TIME_FRAME_SUCCESS,
  payload: data,
});

export const updateMasterTimeFrameFailure = (data) => ({
  type: UPDATE_MASTER_TIME_FRAME_FAILURE,
  payload: data,
});

// Delete Master Time Frame
export const deleteMasterTimeFrame = (data) => ({
  type: DELETE_MASTER_TIME_FRAME,
  payload: data,
});

export const deleteMasterTimeFrameSuccess = (data) => ({
  type: DELETE_MASTER_TIME_FRAME_SUCCESS,
  payload: data,
});

export const deleteMasterTimeFrameFailure = (data) => ({
  type: DELETE_MASTER_TIME_FRAME_FAILURE,
  payload: data,
});

// Get Local Settings Master Config List
export const getLocalSettingsMasterConfigList = () => ({
  type: GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST,
});

export const getLocalSettingsMasterConfigListSuccess = (data) => ({
  type: GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_SUCCESS,
  payload: data,
});

export const getLocalSettingsMasterConfigListFailure = (data) => ({
  type: GET_LOCAL_SETTINGS_MASTER_CONFIG_LIST_FAILURE,
  payload: data,
});

// Get Company Config Items (front-end editable) List
export const getConfigItemsCompanyEditableList = () => ({
  type: GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST,
});

export const getConfigItemsCompanyEditableListSuccess = (data) => ({
  type: GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST_SUCCESS,
  payload: data,
});

export const getConfigItemsCompanyEditableListFailure = (data) => ({
  type: GET_CONFIG_ITEMS_COMPANY_EDITABLE_LIST_FAILURE,
  payload: data,
});

// Update Local Settings Master Config Toggle
export const updateLocalSettingsMasterConfigToggle = (data) => ({
  type: UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE,
  payload: data,
});

export const updateLocalSettingsMasterConfigToggleSuccess = (data) => ({
  type: UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_SUCCESS,
  payload: data,
});

export const updateLocalSettingsMasterConfigToggleFailure = (data) => ({
  type: UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_TOGGLE_FAILURE,
  payload: data,
});

// Get Local Settings Master Config User List
export const getLocalSettingsMasterConfigUserList = () => ({
  type: GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST,
});

export const getLocalSettingsMasterConfigUserListSuccess = (data) => ({
  type: GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_SUCCESS,
  payload: data,
});

export const getLocalSettingsMasterConfigUserListFailure = (data) => ({
  type: GET_LOCAL_SETTINGS_MASTER_CONFIG_USER_LIST_FAILURE,
  payload: data,
});

// Update Local Settings Master Config User
export const updateLocalSettingsMasterConfigUser = (data) => ({
  type: UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER,
  payload: data,
});

export const updateLocalSettingsMasterConfigUserSuccess = (data) => ({
  type: UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_SUCCESS,
  payload: data,
});

export const updateLocalSettingsMasterConfigUserFailure = (data) => ({
  type: UPDATE_LOCAL_SETTINGS_MASTER_CONFIG_USER_FAILURE,
  payload: data,
});
